import { useEffect } from 'react'
import { useStore } from 'react-redux'

import { DevToolDataUpdater } from '../provider/types'

export function useStateMonitor(
  updateData: DevToolDataUpdater,
  isEnabled: boolean
): void {
  const store = useStore()

  useEffect(() => {
    if (!isEnabled) {
      return () => {}
    }

    const updateState = () => {
      const state = store.getState()

      updateData({
        type: 'REDUX_STATE',
        payload: {
          globals: state.globals,
          workspaces: Object.fromEntries(
            Object.entries(state).filter(([key]) => key !== 'globals')
          ),
          currentState: state,
        },
      })
    }

    // Initial state
    updateState()

    const unsubscribe = store.subscribe(updateState)
    return () => unsubscribe()
  }, [updateData, isEnabled, store])
}
